<template>
  <div class="w-100 d-flex justify-content-center align-items-center login">
    <form
      class="flex flex-column justify-content-center align-items-center border login__form"
      @submit.prevent="login"
    >
      <div class="d-flex justify-content-center login__logo">
        <img
          src="~@/assets/favicon.svg"
          alt="Tellimer"
        >
      </div>
      <div class="mt-3">
        <div class="">
          <div
            v-if="forgotPassword"
            class="alert alert-success"
          >
            <h2 class="alert-heading font-weight-bold">
              Success!
            </h2>
            <p>
              If your email is in our system, you will receive an email to get back into your account.
            </p>
            <p class="mb-0">
              Didn't receive the password reset email? Please check your spam folder for an email from <strong><i>support@tellimer.com</i></strong>. If you still do not see an email, please try again.
            </p>
          </div>
          <h1 class="mb-1 text-center">
            Sign into your account
          </h1>
          <div
            v-if="error !== null"
            class="alert alert-warning"
          >
            Invalid username or password.
          </div>
          <label
            for="email"
            class="sr-only"
          >
            Email
          </label>

          <div class="form-group pt-2">
            <input
              class="form-control"
              v-model="data.email"
              type="text"
              placeholder="Your Email"
              aria-label="Your Email"
              aria-describedby="email"
              autocomplete="email"
            />
          </div>

          <div class="form-group">
            <input
              class="form-control"
              v-model="data.password"
              type="password"
              placeholder="Your Password"
              aria-label="Your Password"
              aria-describedby="password"
              autocomplete="current-password"
            />
          </div>

          <div class="d-flex d-sm-none flex-column">
            <button
              type="submit"
              class="flex-grow-1 btn btn-primary justify-content-center align-items-center"
            >
              Sign In
            </button>
            <button
              type="button"
              class="mx-auto  btn btn-link pl-0"
              style="min-width: 100px"
              @click="$modal.show('forgotten-password')"
            >
              Forgotten password?
            </button>
          </div>

          <!-- Big Screen -->
          <div class="d-none d-sm-flex">
            <div>
              <button
                type="button"
                class=" btn btn-link pl-0"
                style="min-width: 100px"
                @click="$modal.show('forgotten-password')"
              >
                Forgotten password?
              </button>
            </div>
            <div class="ml-auto">
              <button
                type="submit"
                class=" btn btn-primary"
                style="min-width: 100px"
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <modal
      :classes="['v--modal', 'vue-dialog']"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      name="forgotten-password"
    >
      <forgotten-password
        modal="forgotten-password"

        @forgot-password-success="forgotPasswordSuccess"
      />
    </modal>
  </div>
</template>

<script>

import ForgottenPassword from '@/views/ForgottenPassword'
import gateway from '@/gateway'

export default {
  components: {
    ForgottenPassword,
  },
  data () {
    return {
      forgotPassword: false,
      manageCookies: false,
      data: {
        email: null,
        password: null,
      },
      loading: false,
      error: null,
    }
  },

  computed: {
    icon () {
      return this.loading ? 'spinner' : 'user'
    },
  },

  methods: {
    forgotPasswordSuccess () {
      this.$modal.hide('forgotten-password')
      this.forgotPassword = true
    },
    login () {
      this.error = null
      this.loading = true
      gateway.post('/auth/login', this.data)
          .then((response) => {
            this.$login.setToken(response.data.token, true)
            this.$http.get('/user')
                .then((response) => {
                  this.loading = false
                  this.$login.setUser(response.data)
                  this.$router.replace({name: 'dashboard'})
                })
                .catch((e) => {
                  this.loading = false
                })
          })
          .catch(({response: {data}}) => {
            this.loading = false
            this.error = data
          })
    },
  },
}
</script>

<style lang="scss">
.login {
  height: 100vh !important;
  background: $header-bar-bg;

  &__form {
    width: 636px;
    padding: 2rem;
    border-radius: 4px;
    background: white;
    svg.i {
      margin-right: 4px;
    }
  }
}
</style>
